;(function () {
  const brandSlider = () => {
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      setTimeout(brandSlider, 100)
      return
    }
    
    const brandSliders = Array.from(
      document.querySelectorAll('.brand-swiper')
    )
    if (brandSliders.length === 0) return
    
    brandSliders.forEach((swiperElement) => {
      // Avoid multiple initializations
      if (swiperElement.classList.contains('slider-initialized')) {
        return;
      }
      swiperElement.classList.add('slider-initialized');
      
      const sectionId = swiperElement.dataset.sectionId
      
      if (!swiperElement) return
      
      // Get settings
      const autoplay = swiperElement.dataset.autoplay === 'true'
      const speed = parseInt(swiperElement.dataset.speed) || 3000
      const slidesDesktop = parseInt(swiperElement.dataset.slidesDesktop) || 5
      const slidesTablet = parseInt(swiperElement.dataset.slidesTablet) || 3
      const slidesMobile = parseInt(swiperElement.dataset.slidesMobile) || 2
      const spaceBetween = parseInt(swiperElement.dataset.spaceBetween) || 30
      
      // Count total slides
      const totalSlides = swiperElement.querySelectorAll('.swiper-slide').length
      
      // Determine if loop should be enabled (need at least 2x slidesPerView for loop)
      // But always enable loop if we have more slides than visible
      const shouldLoop = totalSlides > slidesDesktop
      
      let autoplayConfig = false
      if (autoplay && totalSlides > slidesDesktop) {
        autoplayConfig = {
          delay: speed,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        }
      }
      
      // Initialize Swiper with infinite loop
      const brandSwiper = new Swiper(swiperElement, {
        slidesPerView: slidesDesktop,
        spaceBetween: spaceBetween,
        loop: shouldLoop, // Loop infinito activado
        speed: 1000,
        autoplay: autoplayConfig,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        watchOverflow: true,
        breakpoints: {
          320: {
            slidesPerView: slidesMobile,
            spaceBetween: Math.max(10, spaceBetween - 10),
            loop: totalSlides > slidesMobile
          },
          768: {
            slidesPerView: slidesTablet,
            spaceBetween: Math.max(15, spaceBetween - 5),
            loop: totalSlides > slidesTablet
          },
          1024: {
            slidesPerView: slidesDesktop,
            spaceBetween: spaceBetween,
            loop: shouldLoop
          }
        },
        on: {
          init: function() {
            swiperElement.classList.add('swiper-loaded')
          },
          afterInit: function() {
            // Ensure autoplay starts after initialization
            if (autoplay && this.autoplay && totalSlides > slidesDesktop) {
              this.autoplay.start()
            }
          }
        }
      })
      
      // Handle visibility change
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && brandSwiper.autoplay) {
          brandSwiper.autoplay.stop()
        } else if (!document.hidden && autoplay && brandSwiper.autoplay) {
          brandSwiper.autoplay.start()
        }
      })
    })
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brandSlider)
  } else {
    brandSlider()
  }
  
  // Also initialize on window load to ensure Swiper is loaded
  window.addEventListener('load', brandSlider)
  
  // Handle Shopify section events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.brand-swiper')) {
      setTimeout(brandSlider, 100)
    }
  })
  
  document.addEventListener('shopify:section:unload', function(event) {
    const swiper = event.target.querySelector('.brand-swiper')
    if (swiper) {
      swiper.classList.remove('slider-initialized')
    }
  })
  
})();

